





























































































































import CreateTextbook from './components/Textbook/CreateTextbook.vue'
import EditTextbook from './components/Textbook/EditTextbook.vue'
import { Textbook } from '@/shared/types'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import {
  CREATE_TEXTBOOK,
  EDIT_TEXTBOOK,
  DELETE_TEXTBOOK,
} from '@/shared/user/permissions'
import { alertSymbol } from '@/shared/state-management/symbols'
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  inject,
} from '@vue/composition-api'
import { pagination } from '@/shared/utils'

export default defineComponent({
  name: 'TextbookOverview',
  components: {
    CreateTextbook,
    EditTextbook,
  },
  setup(props, { root }) {
    const data = reactive({
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        // {
        //   text: 'Date',
        //   value: 'date',
        // },
        {
          text: 'Aktionen',
          value: 'actions',
        },
      ],
      search: undefined,
    })
    const $alert = inject(alertSymbol) as Function
    const { getters, actions } = useTextbookStore()
    const { hasPermissionTo } = useUserStore().getters
    const { textbooks, loading } = getters
    const {
      addTextbooks,
      updateTextbook,
      deleteTextbook,
      loadTextbooks,
    } = actions

    const editDialogOpen = ref(false)
    const selectedTextbook = ref(null)
    const showCreateTextbookDialog = ref(false)
    const showCreateTextbookDialogHandler = () => {
      showCreateTextbookDialog.value = true
    }

    const editItem = (item: Textbook) => {
      selectedTextbook.value = item
      editDialogOpen.value = true
    }

    const deleteItem = async (item: Textbook) => {
      await $alert({
        type: 'confirm',
        text: root.$t('textbook.confirmDelete', {
          textbookName: item.name,
        }),
      })
      await deleteTextbook(item.id)
      $alert({
        type: 'success',
        text: root.$t('textbook.deleteSuccess', {
          textbookName: item.name,
        }),
      })
    }

    const onTextbookCreated = (newTextbook: Textbook) => {
      addTextbooks([newTextbook])
      showCreateTextbookDialog.value = false
    }

    const onTextbookEdited = (newTextbook: Textbook) => {
      updateTextbook(newTextbook)
    }

    return {
      ...toRefs(data),
      editItem,
      textbooks,
      editDialogOpen,
      selectedTextbook,
      onTextbookEdited,
      showCreateTextbookDialog,
      showCreateTextbookDialogHandler,
      onTextbookCreated,
      deleteItem,
      loading,
      hasPermissionTo,
      CREATE_TEXTBOOK,
      EDIT_TEXTBOOK,
      DELETE_TEXTBOOK,
      pagination,
    }
  },
})
